import React from "react";
import { Card } from "antd";
import "./EmptyCard.less";

const EmptyCard = (props) => {
  return <Card className='empty-response'>{props.text}</Card>;
};

export default EmptyCard;
